import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://342e4f7e4033bea4fd665fd4dc718e13@o395783.ingest.us.sentry.io/4508309788229632",
  integrations: [
    Sentry.browserTracingIntegration(),
    // Disabled for now to reduce bundle size
    // Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});
